<template>
    <div class="console-wrapper">
        <div class="console-absolute">
            <h1>
                Console
            </h1>
            <div class="console">
                <div v-for="(log_message, index) in buffered_app_debug_log" :key="index" v-bind:style="{ color: log_message.hexColour }" class="row">
                    <div style="width:200px;">
                        <span v-if="log_message.engineName">[{{ log_message.engineName }}]</span>
                        <span v-if="log_message.loggerName">[{{ log_message.loggerName }}]</span>
                    </div>
                    <div class="col" style="word-break: break-all">{{ JSON.stringify(log_message) }}</div>
                </div>
            </div>
        </div>
        -
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                buffered_app_debug_log: [],
                updateViewIntervalHandle: {}
            };
        },
        computed: {
            ...mapState({
                app_debug_log: (state) => state.app_debug_log
            })
        },


        mounted: function () {
            this.updateViewIntervalHandle = setInterval(this.updateView.bind(this), 500);
        },
        beforeUpdate: function () {
            this.removeOldEntries();
        },
        methods: {
            scrollToEnd: function () {
                //console.log($('li:last', this.$el).offset())
                //this.$el.animate({ scrollTop: $('li:last', this.$el).offset().top - 30 });
                //$('.console', this.$el).scrollTop($('.console', this.$el).height() * 10);
                //$('.console', this.$el).scrollTo($('li:last', this.$el));

            },
            updateView: function () {
                console.log('updateView');
                this.buffered_app_debug_log = this.app_debug_log.slice();
                console.log(this.buffered_app_debug_log);
                this.$nextTick(function () {
                    this.scrollToEnd();
                });
            },
            removeOldEntries: function () {
                while (this.app_debug_log.length > 100)
                    this.app_debug_log.shift();
            }
        },
        unmounted: function () {
            clearInterval(this.updateViewIntervalHandle);
        }
    }
</script>

<style>

    .console-wrapper {
        height: 100%;
    }

    .console-absolute {
        position: absolute;
        left: 0;
        width: 100%;
        background-color: #eee;
    }

    .console-absolute h1 {
        padding-left: 25px;
    }

    .console {
        background: #333;
        color: #ccc;
        font-family: monospace;
        overflow-y: auto;
        overflow-wrap: break-word;
        max-width: 100% !important;
        width: auto !important;
        padding: 15px;
        padding-left:25px;
        /*width: 100%;*/ /* = col-md-8 */
    }

</style>
